import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import $ from 'jquery';
import mainLogo from '../assets/images/kanosei/main__logo.png';
import { useAuth } from '../auth/AuthContext';
import { useT } from '../i18n';

// Converted from a class component so it can read auth state via useContext.
function Sidebar() {
    const { t } = useT();
    const { isSignedIn, user, signIn, signOut } = useAuth();

    const backToTop = () => {
        $('html, body').animate({ scrollTop: 0 }, '300');
    };

    /** The panel is opened and closed by a body class that CSS reads. Any
     *  navigation from inside it has to close the panel too, or the new page
     *  renders underneath an open overlay. */
    const closePanel = () => $('body').removeClass('sidebar_active');

    useEffect(() => {
        setTimeout(function () { $("#page-loader").fadeOut(1500); }, 3000);

        // Namespaced and preceded by .off() so this is idempotent. These are
        // delegated handlers on <body>, which outlives the component: without
        // the .off() a remount binds a second copy and every click toggles
        // twice, cancelling itself out. StrictMode double-invokes effects in
        // development, so that is not hypothetical.
        $('body')
            .off('click.sidebar')
            .on('click.sidebar', '.sidebar__toggle', function () {
                $('body').toggleClass('sidebar_active');
            })
            .on('click.sidebar', '.sidebar__cover', function () {
                $('body').removeClass('sidebar_active');
            });

        const btn = $('#back_to_top');
        const onScroll = () => {
            if ($(window).scrollTop() > 300) btn.addClass('show');
            else btn.removeClass('show');
        };

        const $nav = $('body');
        let winH = $(window).height();
        const onFixHeader = function () {
            $nav.toggleClass("fix__header", $(this).scrollTop() > winH);
        };
        const onResize = function () { winH = $(this).height(); };

        $(window)
            .off('scroll.sidebar resize.sidebar')
            .on('scroll.sidebar', onScroll)
            .on('scroll.sidebar', onFixHeader)
            .on('resize.sidebar', onResize);

        return () => {
            $('body').off('click.sidebar');
            $(window).off('scroll.sidebar resize.sidebar');
        };
    }, []);

    return (
        <>
            <div className="sidebar__cover"></div>
            <div className="sidebar">
                <div className="sidebar_inner">
                    <a href="#" className="site__logo"><img src={`${mainLogo}`} alt="" /></a>
                    <p className="desc">{t('nav.tagline')}</p>

                    <div className="sidebar__auth">
                        {isSignedIn ? (
                            <>
                                <Link to="/holdings" className="css_btn" onClick={closePanel}>
                                    <span>{t('common.portfolio')}</span>
                                </Link>
                                <span className="sidebar__auth_email">{user?.email}</span>
                                <button
                                    type="button"
                                    className="sidebar__auth_link"
                                    onClick={() => { closePanel(); signOut(); }}
                                >
                                    {t('common.signOut')}
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                className="css_btn"
                                onClick={() => { closePanel(); signIn('/holdings'); }}
                            >
                                <span>{t('common.signIn')}</span>
                            </button>
                        )}
                    </div>

                    <a className="sidebar__email" href="mailto:info@kanosei.xyz">info@kanosei.xyz</a>
                    <span className="copyright">
                        All Rights Reserved &copy; Kanosei {new Date().getFullYear()}
                    </span>
                </div>
            </div>
            <div className="back_to_top" onClick={backToTop} id="back_to_top">
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21px" height="10px" viewBox="0 0 21 10" enableBackground="new 0 0 21 10" xmlSpace="preserve">
                    <polyline fill="none" stroke="#fff" points="0.5,9.071 10.5,1.727 20.5,9.071 "></polyline>
                </svg>
            </div>
        </>
    );
}

export default Sidebar;
